/** Pathname for the DICOM study list (DataSourceWrapper + WorkList). */
export const STUDY_LIST_PATH = '/worklist';
